import { useEffect, useState } from "react";
import { toast } from "sonner";
import { HeartHandshake, CheckCircle2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { api, errMsg } from "../lib/api";
import { PageHeader } from "../components/app/PageHeader";
import { RatingForm } from "../components/app/EvaluationCards";

const ProgramCard = ({ p, onDone }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ usefulness: 0, accessibility: 0, needs_more_help: null, comment: "", ...(p.my_rating || {}) });
  const send = async () => {
    try { await api.post(`/programs/${p.plan_id}/feedback`, f); toast.success("Salamat! Your feedback was received."); setOpen(false); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-xl border border-amber-700/15 bg-white p-5" data-testid={`program-${p.plan_id}`}>
      <p className="text-[10px] uppercase tracking-widest font-semibold text-amber-800/80">{p.gkk_name}{p.location ? ` · ${p.location}` : ""}</p>
      <p className="mt-1 font-serif-display text-xl font-semibold text-amber-950">{p.intervention}</p>
      <p className="text-xs text-stone-500">{p.start_date || "—"} → {p.target_date || "—"}</p>
      {p.already_rated && !open && <p className="mt-2 flex items-center gap-1 text-xs font-semibold text-[#285E3B]"><CheckCircle2 className="h-4 w-4" />You already shared feedback. You may update it.</p>}
      {!open ? <Button size="sm" variant="outline" className="mt-3" onClick={() => setOpen(true)} data-testid={`rate-${p.plan_id}`}>{p.already_rated ? "Update my feedback" : "Give feedback"}</Button> : (
        <div className="mt-4 space-y-3">
          <RatingForm value={f} onChange={setF} />
          <Textarea rows={2} maxLength={500} placeholder="Optional comment. Please do not include names or private details." value={f.comment} onChange={(e) => setF({ ...f, comment: e.target.value })} data-testid="program-comment-input" />
          <Button disabled={!f.usefulness || !f.accessibility} onClick={send} className="bg-amber-900 hover:bg-[#5B210B]" data-testid="program-feedback-submit">Send feedback</Button>
        </div>
      )}
    </div>
  );
};

export default function ProgramFeedback() {
  const [list, setList] = useState([]);
  const load = () => api.get("/programs/open").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Your voice" title="Program Feedback" testId="programs-header">
        Did a parish program help you? Rating is completely voluntary. Leaders see only totals and averages — never who gave which rating — and averages are shown only once at least 5 people respond.
      </PageHeader>
      <div className="grid gap-4 md:grid-cols-2" data-testid="open-programs-list">
        {list.map((p) => <ProgramCard key={p.plan_id} p={p} onDone={load} />)}
      </div>
      {!list.length && <p className="flex items-center gap-2 text-sm text-stone-500" data-testid="no-programs"><HeartHandshake className="h-4 w-4" />No programs are open for feedback right now.</p>}
    </div>
  );
}
